import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart, ArrowRight } from 'lucide-react';
import axiosInstance from '../../api/axios';

/**
 * BlogMostLovedSection — öffentliche „Beliebte Beiträge"-Sektion oberhalb
 * der Blog-Liste. Zeigt die Top 3 Beiträge nach Like-Anzahl.
 * Wird nur angezeigt, wenn min. 1 Beitrag Likes hat.
 */
const BlogMostLovedSection = () => {
  const [topPosts, setTopPosts] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await axiosInstance.get('/blog/posts', { params: { limit: 50 } });
        const all = res.data || [];
        const withLikes = all
          .filter((p) => (p.likes || 0) > 0)
          .sort((a, b) => (b.likes || 0) - (a.likes || 0))
          .slice(0, 3);
        setTopPosts(withLikes);
      } catch (e) {
        // silent
      }
    })();
  }, []);

  if (topPosts.length === 0) return null;

  return (
    <section
      className="mb-10 p-5 md:p-6 border border-[#E8DCC8]"
      style={{ background: 'linear-gradient(135deg, #FAF5EE 0%, #F5EDE4 100%)' }}
      data-testid="blog-most-loved-section"
    >
      <div className="flex items-center gap-2 mb-4">
        <Heart className="h-5 w-5" fill="#E27158" strokeWidth={0} />
        <h2 className="text-lg font-semibold text-[#5D4E3C]">Beliebt bei Leserinnen & Lesern</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {topPosts.map((post, idx) => (
          <Link
            key={post.id}
            to={`/blog/${post.id}`}
            className="group block bg-white p-4 border border-[#E8DCC8] hover:border-[#C4A084] hover:-translate-y-0.5 transition-all"
            data-testid={`blog-most-loved-${idx + 1}`}
          >
            <div className="flex items-start justify-between gap-3 mb-2">
              <span
                className="inline-flex items-center justify-center w-7 h-7 text-xs font-bold rounded-full flex-shrink-0"
                style={{
                  background: idx === 0 ? '#FBE4DA' : '#F5EDE4',
                  color: idx === 0 ? '#B0512E' : '#8B7355',
                }}
              >
                {idx + 1}
              </span>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-[#B0512E]">
                <Heart className="h-3.5 w-3.5" fill="#E27158" strokeWidth={0} />
                {post.likes}
              </span>
            </div>
            {post.category && (
              <p className="text-[10px] tracking-[2px] text-[#8B7355] uppercase mb-1">
                {post.category}
              </p>
            )}
            <h3 className="text-sm font-medium text-[#5D4E3C] leading-snug line-clamp-2 group-hover:text-[#8B6F4D] mb-2">
              {post.title}
            </h3>
            <span className="inline-flex items-center gap-1 text-[11px] text-[#8B6F4D] group-hover:gap-2 transition-all">
              Lesen <ArrowRight className="h-3 w-3" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default BlogMostLovedSection;
